import React, { memo } from 'react';
import PropTypes from 'prop-types';

const MaintenanceAltColored = ({
  screwdriverFill,
  wrenchBorderColor,
  ...props
}) => (
  <svg viewBox="0 0 60 60" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        fill={wrenchBorderColor}
        d="m2.774 54.2 4.538 4.538 16.638-18.15-4.537-4.538L2.774 54.2ZM46.64 7.31l6.05 6.051 6.05-7.563-4.537-4.538-7.563 6.05Z"
      />
      <path
        fill={screwdriverFill}
        d="m35.962 29.12 8.767 8.838.383-.12a11.183 11.183 0 0 1 10.836 2.549l.31.301a11.368 11.368 0 0 1 2.396 12.409 1.26 1.26 0 0 1-1.887.543l-.134-.109-5.012-4.664h-3.235v3.263l4.727 4.943a1.26 1.26 0 0 1-.264 1.953l-.154.078a11.192 11.192 0 0 1-12.339-2.417 11.36 11.36 0 0 1-2.826-11.21l.124-.4-8.78-8.849 1.79-1.775 9.35 9.423c.36.362.465.905.267 1.376-1.377 3.28-.674 7.104 1.864 9.66a8.664 8.664 0 0 0 7.419 2.475l.312-.053-3.66-3.827a1.26 1.26 0 0 1-.335-.678l-.015-.193v-5.028c0-.643.481-1.173 1.102-1.251l.159-.01h4.99c.255 0 .502.077.71.22l.149.118 3.895 3.625.06-.354a8.837 8.837 0 0 0-2.198-7.214l-.264-.278a8.665 8.665 0 0 0-9.563-1.876 1.26 1.26 0 0 1-1.261-.16l-.128-.112-9.345-9.42 1.79-1.776ZM54.274.228a1.26 1.26 0 0 1 1.617.145l3.743 3.771a1.26 1.26 0 0 1 .118 1.639l-6.403 8.631a1.26 1.26 0 0 1-1.907.138l-2.06-2.075-24.869 25.06 4.409 4.443a1.26 1.26 0 0 1-1.661 1.889l-.129-.113-1.75-1.766-15.5 15.622a4.977 4.977 0 0 1-6.907.17l-.175-.168a5.047 5.047 0 0 1 0-7.107l15.515-15.64-1.763-1.777a1.26 1.26 0 0 1 1.661-1.889l.129.114 4.396 4.432 24.868-25.058-2.34-2.355a1.26 1.26 0 0 1 .065-1.837l.107-.084ZM20.087 36.659 4.59 52.283a2.527 2.527 0 0 0 .002 3.557 2.456 2.456 0 0 0 3.5-.003l15.513-15.634-3.517-3.544Zm-.899-33.324c2.959 2.979 3.978 7.294 2.826 11.213l-.125.398 8.775 8.84-1.789 1.776-9.345-9.413a1.26 1.26 0 0 1-.267-1.376c1.377-3.28.674-7.107-1.863-9.661-1.994-2.008-4.64-2.865-7.246-2.478l-.398.07 3.383 3.845c.162.184.266.41.301.65l.013.182v5.029a1.26 1.26 0 0 1-1.102 1.25l-.158.01h-4.99a1.26 1.26 0 0 1-.713-.22l-.148-.12L2.67 9.9l-.057.337a8.684 8.684 0 0 0 2.198 7.137l.265.279c2.518 2.54 6.297 3.22 9.561 1.825a1.26 1.26 0 0 1 1.261.158l.128.113 9.347 9.398-1.787 1.778-8.77-8.819-.386.125c-3.77 1.134-7.898.24-10.834-2.502l-.31-.3A11.222 11.222 0 0 1 .89 7.108a1.26 1.26 0 0 1 1.89-.541l.133.108 4.785 4.472h3.234V7.855l-4.35-4.944A1.26 1.26 0 0 1 6.886.995l.15-.076c4.177-1.78 8.88-.879 12.153 2.416Zm35.66-.433-6.739 4.716 4.089 4.116 4.882-6.585-2.232-2.247Z"
      />
    </g>
  </svg>
);

MaintenanceAltColored.defaultProps = {
  width: 60,
  height: 60,
  screwdriverFill: '#042238',
  wrenchBorderColor: '#7FE3FF',
};

MaintenanceAltColored.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  screwdriverFill: PropTypes.string,
  wrenchBorderColor: PropTypes.string,
};

export default memo(MaintenanceAltColored);
